import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import styled from "styled-components";
import HomepageRoutes from "./HomepageRoutes";
import Header from "./components/Header";
import Footer from "./components/Footer/index";
import usePylon from "hooks/usePylon";

const Homepage: React.FC = () => {
  const containerRef = useRef<HTMLDivElement>(null);
  const { pathname } = useLocation();
  const location = useLocation();

  // Initialize Pylon chat widget for homepage
  usePylon();

  useEffect(() => {
    containerRef.current?.scrollTo(0, 0);
  }, [pathname]);

  return (
    <Container ref={containerRef}>
      <Helmet>
        <title>AI Infrastructure For Developers</title>
        <link rel="canonical" href={`${window.location.origin}${location.pathname}`} />
        <meta
          name="description"
          content={
            "Ultrafast sandbox environments for AI agents. Bring your own custom image and run untrusted code safely – at scale."
          }
        />
        <meta property="og:type" content="website" />
        <meta
          property="og:title"
          content={`Secure Sandboxes
for AI Agents • Beam`}
        />
        <meta
          property="og:description"
          content={
            "Ultrafast sandbox environments for AI agents. Bring your own custom image and run untrusted code safely – at scale."
          }
        />
        <meta property="og:image" content={"https://www.beam.cloud/meta-hero.png"} />
        <meta property="og:url" content={window.location.href} />
        <meta
          name="twitter:title"
          content={`Secure Sandboxes
for AI Agents • Beam`}
        />
        <meta
          name="twitter:description"
          content={
            "Ultrafast sandbox environments for AI agents. Bring your own custom image and run untrusted code safely – at scale."
          }
        />
        <meta name="twitter:image" content={"https://www.beam.cloud/meta-hero.png"} />
        <meta name="twitter:card" content="summary_large_image" />
      </Helmet>
      <Header />
      <Main>
        <HomepageRoutes />
      </Main>
      <Footer />
    </Container>
  );
};

export default Homepage;

const Container = styled.div`
  position: relative;
  overflow: hidden;
  overflow-y: auto;
  position: relative;
  height: 100vh;
  width: 100vw;
  background-color: ${props => props.theme.colors.gray1};

  display: grid;
  grid-template-rows: auto 1fr auto;
`;

const Main = styled.main``;
